<div class="card-component">
  <kendo-grid #grid [kendoGridBinding]="gridView">

    <kendo-grid-column field="data" [title]="customMsgService.translate('movDataHora')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.dataCriacao | date:"yyyy-MM-dd HH:mm:ss" }} </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="descricaoEstado" [title]="customMsgService.translate('estado')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
          <span kendoTooltip title="{{customMsgService.translate('datahoraAtualizacao')}}: {{dataItem.dataAtualizacao | date:'yyyy-MM-dd HH:mm:ss'}}">    
              <div class="customer-name"> {{ dataItem.descricaoEstado }} </div>
          </span>
      </ng-template>
  </kendo-grid-column>

    <kendo-grid-column field="descricaometodoPagamento" [title]="customMsgService.translate('metodoPagamento')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.descricaoMetodoPagamento }} </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="montante" [title]="customMsgService.translate('montante')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.montante | number:'1.2-2' }}€ </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="fatura" [title]="customMsgService.translate('fatura')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
          <button kendoGridEditCommand icon="file-txt"
          (click)="openInvoiceForm(dataItem)" [primary]="true"></button>
      </ng-template>
  </kendo-grid-column>

  </kendo-grid>
</div>
